import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/error",
    component: () => import("@/views/Error")
  },
  {
    path: "/forgot-password",
    component: () => import("@/views/ForgotPassword")
  },
  {
    path: "/login",
    component: () => import("@/views/Login")
  },
  {
    path: "/register",
    component: () => import("@/views/Register")
  },
  {
    path: "/:gluidId",
    component: () => import("@/views/Home"),
    beforeEnter: async (to, from, next) => {
      await getAuth(next);
      store.dispatch("fetchAllUserSpacesForUser");
      if (
        to.params.gluidId !==
        store.state.userIdToken.payload["cognito:username"]
      ) {
        router.replace(
          `/${store.state.userIdToken.payload["cognito:username"]}`
        );
      } else {
        next();
      }
    }
  },
  {
    path: "/",
    beforeEnter: async (to, from, next) => {
      try {
        const user = await store.dispatch("cognito/fetchSession");
        const username = user.idToken.payload["cognito:username"];
        if (username) {
          next(`${username}`);
        } else {
          next("/login");
        }
      } catch {
        next("/login");
      }
    }
  },
  {
    path: "*",
    component: () => import("@/views/GluidApp"),
    beforeEnter: async (to, from, next) => {
      await getAuth(next);
      if (store.state.userToken) {
        try {
          await store.dispatch("initializeApp", to.path);
        } catch (error) {
          next({
            path: "/error",
            query: { error: `There is no workspace on ${to.path}` },
            replace: true
          });
        }
      }

      next();
    }
  }
];

const getAuth = async next => {
  if (!store.state.userToken) {
    let problem = false;
    try {
      await store.dispatch("cognito/fetchSession");
    } catch (e) {
      problem = true;
    }
    if (problem || !store.getters["cognito/isLoggedIn"]) {
      next("/login");
    } else {
      if (!store.state.userToken) {
        const jwt = await store.dispatch("cognito/fetchJwtToken");
        const { idToken } = await store.dispatch("cognito/fetchSession");
        store.commit("setUserIdToken", idToken);
        store.commit("setUserToken", jwt);
        return jwt;
      }
    }
  }
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
